export { Buffer } from '_node-buffer-polyfill_.js'
